// SEO Content: Köln Stadtteile Teil 2
// Mülheim, Porz, Chorweiler, Rodenkirchen und weitere

const seoContentKoeln2 = {
  // Stadtteil: Mülheim
  muelheim: {
    heroTitle: "Maler in Köln-Mülheim – Tradition trifft Wandel",
    heroSubtitle: "Professionelle Malerarbeiten im vielfältigen Mülheim. Von der Keupstraße bis zum Rheinufer.",

    mainContent: {
      intro: `Mülheim ist einer der größten und vielfältigsten Stadtteile Kölns. Das rechtsrheinische Viertel erstreckt sich vom Rheinufer bis zur Bergischen Landstraße und bietet eine einzigartige Mischung aus Kulturen, Architekturen und Lebensstilen. Die Keupstraße ist das Herz der türkischen Gemeinde, während am Rhein moderne Wohnanlagen entstehen.

Als Malerbetrieb erleben wir diese Vielfalt täglich. Wir arbeiten in den türkischen Geschäften ebenso wie in den Altbauwohnungen oder den neuen Lofts. Mülheim ist bunt – im wörtlichen Sinne.`,

      localExpertise: `Mülheim hat viele Gesichter. Die Mülheimer Freiheit mit ihren Geschäften und Restaurants, die ruhigen Wohnstraßen dahinter, die Industriegebiete im Osten, die neuen Wohnprojekte am Rhein. Jeder Bereich hat seine eigenen Anforderungen.

Die Bebauung ist entsprechend vielfältig: Gründerzeitbauten, Arbeitersiedlungen, moderne Neubauten. Manche Gebäude sind gepflegt, andere brauchen dringend eine Auffrischung. Wir helfen gerne – mit Lösungen für jedes Budget.

Die multikulturelle Bevölkerung schätzen wir besonders. Hier spricht man miteinander, egal woher man kommt. Diese Offenheit prägt auch unsere Arbeit in Mülheim.`,

      services: `Unser Angebot für Mülheim:

- **Geschäftsräume Keupstraße**: Schnell, sauber, angepasst an Öffnungszeiten
- **Altbauwohnungen**: Solide Renovierung für die Gründerzeitbauten
- **Neubauten am Rhein**: Moderne Gestaltung für zeitgemäßes Wohnen
- **Fassadensanierung**: Aufwertung für sanierungsbedürftige Gebäude
- **Bezahlbare Lösungen**: Gute Qualität auch für kleinere Budgets`,

      whyUs: `In Mülheim sind wir Teil der Gemeinschaft. Wir verstehen die verschiedenen Kulturen und Bedürfnisse. Unsere Arbeit trägt dazu bei, das Viertel Schritt für Schritt schöner zu machen.`
    },

    faq: [
      {
        question: "Arbeiten Sie auch in den Geschäften an der Keupstraße?",
        answer: "Ja, wir renovieren regelmäßig Geschäftsräume im Zentrum von Mülheim. Flexible Arbeitszeiten sind selbstverständlich."
      },
      {
        question: "Haben Sie Erfahrung mit den älteren Gebäuden in Mülheim?",
        answer: "Ja, die Gründerzeitbauten und auch die Nachkriegsbauten in Mülheim kennen wir gut."
      },
      {
        question: "Bieten Sie auch günstige Renovierungen an?",
        answer: "Ja, wir haben Lösungen für verschiedene Budgets. Sprechen Sie uns an."
      }
    ],

    nearbyAreas: [
      { name: "Deutz", slug: "deutz" },
      { name: "Kalk", slug: "kalk" },
      { name: "Buchforst", slug: "buchforst" },
      { name: "Buchheim", slug: "buchheim" },
      { name: "Holweide", slug: "holweide" }
    ],

    meta: {
      title: "Maler Köln-Mülheim | Vielfalt & Qualität | FarbWelt Service",
      description: "Ihr Maler in Mülheim ✓ Geschäft ✓ Wohnung ✓ Alle Budgets. Malerarbeiten im vielfältigen Mülheim!",
      keywords: "Maler Mülheim, Maler Köln-Mülheim, Wohnung streichen Mülheim"
    }
  },

  // Stadtteil: Porz
  porz: {
    heroTitle: "Maler in Köln-Porz – Ihr Partner am Stadtrand",
    heroSubtitle: "Professionelle Malerarbeiten in Porz und allen Ortsteilen. Vom Einfamilienhaus bis zum Gewerbebau.",

    mainContent: {
      intro: `Porz ist der südöstlichste Stadtbezirk Kölns und mit seinen vielen Ortsteilen fast wie eine eigene Stadt. Von Wahn mit dem Flughafen über Ensen am Rhein bis zu den ruhigen Wohngebieten von Urbach und Elsdorf – Porz bietet Raum zum Leben. Die Nähe zum Flughafen und die gute Autobahnanbindung machen den Bezirk attraktiv für Pendler und Familien.

Als Malerbetrieb sind wir in ganz Porz unterwegs. Die überwiegend kleinteilige Bebauung mit Einfamilienhäusern und kleineren Mehrfamilienhäusern entspricht unserem Arbeitsbereich perfekt.`,

      localExpertise: `Porz ist grüner und ruhiger als die Kölner Innenstadt. Hier dominieren Einfamilienhäuser und Reihenhäuser, dazwischen Siedlungen und einige Hochhäuser. Die Menschen hier schätzen das Bodenständige – und genau so arbeiten wir.

Die Nähe zum Flughafen prägt den Stadtteil. In Wahn und Umgebung gibt es viel Gewerbe, Hotels und Büros. Diese betreuen wir ebenso wie die privaten Haushalte in den Wohngebieten.

Porz hat auch seine historischen Ecken. In Zündorf am Rhein stehen alte Fischerhäuser, in Ensen gibt es noch dörfliche Strukturen. Diese besonderen Gebäude behandeln wir mit der nötigen Sorgfalt.`,

      services: `Unser Angebot für Porz:

- **Einfamilienhäuser**: Innen und außen, komplett oder teilweise
- **Reihenhäuser**: Effiziente Renovierung für gleichartige Objekte
- **Fassadenarbeiten**: Schutz und Schönheit für Ihr Haus
- **Gewerberäume**: Hotels, Büros, Gewerbeflächen am Flughafen
- **Historische Gebäude**: Behutsame Sanierung in Zündorf und Ensen`,

      whyUs: `In Porz profitieren Sie von unserer Erfahrung mit Eigenheimen. Wir verstehen, was Hausbesitzer brauchen – und liefern genau das.`
    },

    faq: [
      {
        question: "Arbeiten Sie in allen Ortsteilen von Porz?",
        answer: "Ja, wir sind in ganz Porz tätig – von Wahn über Zündorf bis Urbach und Elsdorf."
      },
      {
        question: "Bieten Sie auch Fassadenanstriche für Einfamilienhäuser an?",
        answer: "Ja, Fassadenarbeiten für Eigenheime sind einer unserer Schwerpunkte in Porz."
      },
      {
        question: "Berechnen Sie Anfahrtskosten nach Porz?",
        answer: "Nein, Porz gehört zu Köln und damit zu unserem regulären Einzugsgebiet ohne Aufpreis."
      }
    ],

    nearbyAreas: [
      { name: "Poll", slug: "poll" },
      { name: "Ensen", slug: "ensen" },
      { name: "Wahn", slug: "wahn" },
      { name: "Zündorf", slug: "zuendorf" },
      { name: "Gremberghoven", slug: "gremberghoven" }
    ],

    meta: {
      title: "Maler Köln-Porz | Eigenheim & Gewerbe | FarbWelt Service",
      description: "Ihr Maler in Porz ✓ Einfamilienhaus ✓ Fassade ✓ Alle Ortsteile. Malerarbeiten am Kölner Stadtrand!",
      keywords: "Maler Porz, Maler Köln-Porz, Haus streichen Porz, Fassade Porz"
    }
  },

  // Stadtteil: Chorweiler
  chorweiler: {
    heroTitle: "Maler in Köln-Chorweiler – Zuverlässig und Fair",
    heroSubtitle: "Professionelle Malerarbeiten in Chorweiler und Umgebung. Ihr lokaler Malerbetrieb im Kölner Norden.",

    mainContent: {
      intro: `Chorweiler ist der nördlichste Stadtbezirk Kölns. Der Name steht oft für die Hochhaussiedlung, dabei gehören auch ruhige Ortsteile wie Fühlingen, Seeberg und Heimersdorf zum Bezirk. Die Mischung aus Großsiedlung, Einfamilienhäusern und dörflichen Strukturen macht Chorweiler vielfältiger als sein Ruf.

Als Malerbetrieb arbeiten wir in allen Teilen von Chorweiler. Ob Hochhauswohnung oder Eigenheim – wir bringen überall die gleiche Qualität und Zuverlässigkeit.`,

      localExpertise: `Chorweiler hat seine eigenen Gegebenheiten. In der Großsiedlung arbeiten wir oft bei Auszügen und Einzügen – schnelle, effiziente Renovierungen sind gefragt. Die Hochhäuser erfordern manchmal Abstimmung mit der Hausverwaltung.

Die ruhigeren Ortsteile sind anders geprägt. In Fühlingen am See, in Seeberg und Heimersdorf stehen Einfamilienhäuser und kleinere Mehrfamilienhäuser. Hier geht es oft um Fassadenarbeiten oder umfangreichere Renovierungen.

Wir behandeln alle Kunden gleich – ob Sozialwohnung oder Eigenheim. Jeder verdient ordentliche Arbeit zu fairen Preisen.`,

      services: `Unser Angebot für Chorweiler:

- **Express-Renovierung**: Schnelle Wohnungsübergabe bei Mieterwechsel
- **Einfamilienhäuser**: Komplette Renovierung innen und außen
- **Fassadenarbeiten**: Für Eigenheime in den ruhigeren Ortsteilen
- **Hochhauswohnungen**: Effiziente Arbeit mit Abstimmung zur Hausverwaltung
- **Faire Preise**: Gute Qualität für jedes Budget`,

      whyUs: `In Chorweiler sind wir fair und zuverlässig. Wir machen keine Unterschiede – jeder Auftrag ist uns wichtig.`
    },

    faq: [
      {
        question: "Arbeiten Sie auch in den Hochhäusern von Chorweiler?",
        answer: "Ja, wir sind die Arbeit in Hochhäusern gewohnt und stimmen uns bei Bedarf mit der Hausverwaltung ab."
      },
      {
        question: "Bieten Sie günstige Auszugsrenovierungen an?",
        answer: "Ja, schnelle Wohnungsübergabe-Renovierungen zu fairen Preisen sind einer unserer Schwerpunkte."
      },
      {
        question: "Sind Sie auch in Fühlingen und Heimersdorf tätig?",
        answer: "Ja, wir arbeiten im gesamten Stadtbezirk Chorweiler, auch in den ruhigeren Ortsteilen."
      }
    ],

    nearbyAreas: [
      { name: "Seeberg", slug: "seeberg" },
      { name: "Heimersdorf", slug: "heimersdorf" },
      { name: "Fühlingen", slug: "fuehlingen" },
      { name: "Blumenberg", slug: "blumenberg" },
      { name: "Worringen", slug: "worringen" }
    ],

    meta: {
      title: "Maler Köln-Chorweiler | Fair & Zuverlässig | FarbWelt Service",
      description: "Ihr Maler in Chorweiler ✓ Alle Ortsteile ✓ Faire Preise ✓ Schnelle Renovierung. Malerarbeiten im Kölner Norden!",
      keywords: "Maler Chorweiler, Maler Köln-Chorweiler, Wohnung streichen Chorweiler"
    }
  },

  // Stadtteil: Rodenkirchen
  rodenkirchen: {
    heroTitle: "Maler in Köln-Rodenkirchen – Leben am Rhein",
    heroSubtitle: "Professionelle Malerarbeiten in der grünen Rheinlage. Ihr Malerbetrieb für anspruchsvolle Projekte.",

    mainContent: {
      intro: `Rodenkirchen ist einer der begehrtesten Wohnorte in Köln. Der Stadtbezirk im Süden erstreckt sich entlang des Rheins und bietet eine einzigartige Mischung aus urbanem Leben und Naherholung. Rodenkirchen selbst, Sürth, Weiß und Hahnwald gehören zu den besten Adressen der Stadt.

Als Malerbetrieb sind wir regelmäßig in Rodenkirchen tätig. Die anspruchsvollen Kunden hier erwarten höchste Qualität – und genau das liefern wir.`,

      localExpertise: `Rodenkirchen ist geprägt von gepflegten Einfamilienhäusern, großzügigen Villen und gehobenen Wohnungen. Die Nähe zum Rhein und zum Forstbotanischen Garten macht das Viertel besonders attraktiv. Die Menschen hier legen Wert auf Qualität und ein ansprechendes Erscheinungsbild.

Hahnwald ist die exklusivste Adresse im Bezirk – hier stehen einige der teuersten Häuser Kölns. Auch in Sürth und Weiß gibt es viele hochwertige Immobilien. Diese Objekte erfordern erstklassige Arbeit und diskrete Abwicklung.

Die Rheinlage bringt besondere Anforderungen für Fassaden mit sich. Wind und Feuchtigkeit vom Fluss setzen Anstrichen zu. Wir kennen diese Bedingungen und setzen entsprechend robuste Materialien ein.`,

      services: `Unser Angebot für Rodenkirchen:

- **Villen & Exklusive Häuser**: Höchste Qualität für höchste Ansprüche
- **Gehobene Wohnungen**: Sauber, präzise, termingerecht
- **Fassadenarbeiten**: Wetterfeste Lösungen für die Rheinlage
- **Lackierarbeiten**: Hochwertige Aufarbeitung von Türen und Fenstern
- **Diskrete Abwicklung**: Professionell und vertraulich`,

      whyUs: `In Rodenkirchen erwarten Kunden das Beste – und das liefern wir. Unsere Arbeit hier ist Referenz und Ansporn zugleich.`
    },

    faq: [
      {
        question: "Haben Sie Erfahrung mit Villen in Hahnwald?",
        answer: "Ja, wir haben bereits in mehreren Häusern in Hahnwald gearbeitet und kennen die Anforderungen an Qualität und Diskretion."
      },
      {
        question: "Wie gehen Sie mit der Rhein-Feuchtigkeit bei Fassaden um?",
        answer: "Wir verwenden spezielle, feuchtigkeitsbeständige Fassadenfarben und achten auf gründliche Untergrundvorbereitung."
      },
      {
        question: "Bieten Sie auch Referenzen in Rodenkirchen?",
        answer: "Ja, wir können Ihnen auf Wunsch Referenzen im Stadtbezirk nennen."
      }
    ],

    nearbyAreas: [
      { name: "Sürth", slug: "suerth" },
      { name: "Weiß", slug: "weiss" },
      { name: "Hahnwald", slug: "hahnwald" },
      { name: "Bayenthal", slug: "bayenthal" },
      { name: "Marienburg", slug: "marienburg" }
    ],

    meta: {
      title: "Maler Köln-Rodenkirchen | Premium-Qualität | FarbWelt Service",
      description: "Ihr Maler in Rodenkirchen ✓ Villen ✓ Exklusive Häuser ✓ Rheinlage. Malerarbeiten für höchste Ansprüche!",
      keywords: "Maler Rodenkirchen, Maler Köln-Rodenkirchen, Villa streichen Köln Süd"
    }
  },

  // Stadtteil: Sülz
  suelz: {
    heroTitle: "Maler in Köln-Sülz – Studenten und Familien",
    heroSubtitle: "Professionelle Malerarbeiten im lebendigen Sülz. Ihr Malerbetrieb für Altbau und modernes Wohnen.",

    mainContent: {
      intro: `Sülz ist einer der beliebtesten Stadtteile Kölns – lebendig, grün und vielfältig. Das Viertel zwischen Uni und Stadtwald zieht Studenten, junge Berufstätige und Familien gleichermaßen an. Die Zülpicher Straße ist legendär für ihr Nachtleben, während in den Seitenstraßen beschauliches Wohnen möglich ist.

Als Malerbetrieb sind wir in Sülz häufig gefragt. Die Mischung aus studentischen WGs, Familienwohnungen und gehobenen Altbauten macht die Arbeit hier abwechslungsreich.`,

      localExpertise: `Sülz ist ein typisches Kölner Altbauviertel. Gründerzeitbauten mit hohen Decken und Stuckelementen prägen das Bild. Viele Wohnungen werden von Studenten gemietet – entsprechend hoch ist die Fluktuation, entsprechend oft werden Renovierungen benötigt.

Die Nähe zur Universität sorgt für eine junge, dynamische Atmosphäre. Die Kunden hier sind oft unkompliziert und preisbewusst, aber nicht anspruchslos. Sie erwarten gute Arbeit zu fairen Preisen – und genau das bieten wir.

In Richtung Lindenthal wird es ruhiger und gehobener. Die Straßen am Stadtwald ziehen Familien und wohlhabendere Mieter an. Hier sind die Ansprüche entsprechend höher.`,

      services: `Unser Angebot für Sülz:

- **WG-Renovierung**: Schnell und günstig für studentisches Budget
- **Altbauwohnungen**: Sorgfältige Arbeit an Stuck und hohen Decken
- **Familienwohnungen**: Schadstoffarme Farben für Kinderzimmer
- **Auszugsrenovierung**: Express-Service bei Mieterwechsel
- **Gehobene Wohnungen**: Premium-Qualität Richtung Lindenthal`,

      whyUs: `In Sülz verstehen wir die unterschiedlichen Bedürfnisse – von der studentischen WG bis zur Familienwohnung. Für jeden Anspruch haben wir das passende Angebot.`
    },

    faq: [
      {
        question: "Bieten Sie günstige Renovierungen für WGs an?",
        answer: "Ja, wir haben spezielle Angebote für studentisches Budget. Sprechen Sie uns an."
      },
      {
        question: "Kennen Sie sich mit den Sülzer Altbauten aus?",
        answer: "Ja, die Gründerzeitbauten mit ihren hohen Decken und Stuckelementen sind unser tägliches Geschäft."
      },
      {
        question: "Wie schnell können Sie eine Auszugsrenovierung durchführen?",
        answer: "Bei guter Planung ist eine Wohnung in 2-4 Tagen fertig renoviert."
      }
    ],

    nearbyAreas: [
      { name: "Klettenberg", slug: "klettenberg" },
      { name: "Lindenthal", slug: "lindenthal" },
      { name: "Zollstock", slug: "zollstock" },
      { name: "Neustadt-Süd", slug: "neustadt-sued" }
    ],

    meta: {
      title: "Maler Köln-Sülz | Altbau & WG | FarbWelt Service",
      description: "Ihr Maler in Sülz ✓ Altbau ✓ WG ✓ Familie. Malerarbeiten im beliebten Univiertel!",
      keywords: "Maler Sülz, Maler Köln-Sülz, WG renovieren Sülz, Altbau streichen Köln"
    }
  },

  // Stadtteil: Klettenberg
  klettenberg: {
    heroTitle: "Maler in Köln-Klettenberg – Ruhe am Stadtwald",
    heroSubtitle: "Professionelle Malerarbeiten im grünen Klettenberg. Ihr Spezialist für gepflegte Wohnlagen.",

    mainContent: {
      intro: `Klettenberg ist eine Oase der Ruhe. Der kleine Stadtteil zwischen Sülz und Zollstock grenzt direkt an den Äußeren Grüngürtel und den Klettenbergpark. Die überwiegende Einfamilienhausbebauung, die Nähe zur Natur und die gute Anbindung machen Klettenberg zum idealen Wohnort für Familien und Naturliebhaber.

Als Malerbetrieb schätzen wir die Arbeit in Klettenberg. Die gepflegten Häuser und anspruchsvollen Kunden motivieren uns zu bester Arbeit.`,

      localExpertise: `Klettenberg ist von Einfamilienhäusern und kleinen Mehrfamilienhäusern geprägt. Viele der Gebäude stammen aus den 1920er und 30er Jahren und haben ihren eigenen Charakter bewahrt. Die Bewohner legen Wert auf ein gepflegtes Erscheinungsbild – ihrer Häuser und des gesamten Viertels.

Die Bebauung ist überschaubar und einheitlich. Hier gibt es keine Hochhäuser, keine Gewerbegebiete, nur Wohnen im Grünen. Diese Ruhe und Qualität spiegelt sich in den Anforderungen unserer Kunden wider.

Fassadenarbeiten sind in Klettenberg besonders wichtig. Ein gepflegtes Haus wertet die ganze Straße auf. Wir achten darauf, dass unsere Arbeit ins Gesamtbild passt.`,

      services: `Unser Angebot für Klettenberg:

- **Einfamilienhäuser**: Innen und außen, komplett oder teilweise
- **Fassadenanstriche**: Für das gepflegte Erscheinungsbild
- **Innenrenovierung**: Wohngesunde Farben für Familienheime
- **Historische Gebäude**: Behutsame Sanierung der 20er/30er-Jahre-Bauten
- **Gartenhäuser**: Auch kleine Projekte sind willkommen`,

      whyUs: `In Klettenberg arbeiten wir mit Sorgfalt und Respekt vor der Umgebung. Wir wissen, dass jedes Projekt zum Gesamtbild des Viertels beiträgt.`
    },

    faq: [
      {
        question: "Arbeiten Sie auch an älteren Häusern aus den 1920er Jahren?",
        answer: "Ja, wir haben Erfahrung mit der Sanierung historischer Gebäude und verwenden geeignete Materialien und Techniken."
      },
      {
        question: "Wie wichtig ist Ihnen das Erscheinungsbild des Viertels?",
        answer: "Sehr wichtig. Wir beraten zur Farbwahl und achten darauf, dass das Ergebnis ins Straßenbild passt."
      },
      {
        question: "Streichen Sie auch kleinere Objekte wie Gartenhäuser?",
        answer: "Ja, auch kleine Projekte führen wir gerne durch."
      }
    ],

    nearbyAreas: [
      { name: "Sülz", slug: "suelz" },
      { name: "Zollstock", slug: "zollstock" },
      { name: "Raderthal", slug: "raderthal" },
      { name: "Raderberg", slug: "raderberg" }
    ],

    meta: {
      title: "Maler Köln-Klettenberg | Eigenheim & Natur | FarbWelt Service",
      description: "Ihr Maler in Klettenberg ✓ Einfamilienhaus ✓ Fassade ✓ Gepflegte Wohnlage. Malerarbeiten am Stadtwald!",
      keywords: "Maler Klettenberg, Maler Köln-Klettenberg, Haus streichen Klettenberg"
    }
  },

  // Stadtteil: Poll
  poll: {
    heroTitle: "Maler in Köln-Poll – Dorf in der Großstadt",
    heroSubtitle: "Professionelle Malerarbeiten im idyllischen Poll. Ihr Malerbetrieb für das Rheinufer.",

    mainContent: {
      intro: `Poll hat sich seinen dörflichen Charakter bewahrt. Der kleine Stadtteil am rechten Rheinufer wirkt wie eine Oase zwischen Deutz und Porz. Die Poller Wiesen, die historische Maternuskapelle und die Nähe zum Wasser machen Poll zu einem besonderen Wohnort.

Als Malerbetrieb arbeiten wir gerne in Poll. Die überschaubare Größe, die netten Menschen und die schöne Lage machen jeden Auftrag hier angenehm.`,

      localExpertise: `Poll ist klein und überschaubar. Die Bebauung ist gemischt – Einfamilienhäuser, kleinere Mehrfamilienhäuser und einige Neubauten direkt am Rhein. Der dörfliche Charakter zeigt sich auch in den Gebäuden: Hier gibt es noch originale Fischerhäuser und traditionelle Architektur.

Die Lage am Rhein hat auch ihre Herausforderungen. Feuchtigkeit und gelegentliches Hochwasser setzen Gebäuden zu. Wir kennen diese Bedingungen und verwenden entsprechend robuste Materialien.

In Poll kennt man sich. Mundpropaganda ist wichtig. Wir arbeiten so, dass man uns weiterempfiehlt – und das tun die Poller gerne.`,

      services: `Unser Angebot für Poll:

- **Einfamilienhäuser**: Innen und außen, mit Liebe zum Detail
- **Fassaden am Rhein**: Feuchtigkeitsbeständige Materialien
- **Historische Gebäude**: Behutsame Sanierung traditioneller Architektur
- **Neubauten am Wasser**: Moderne Gestaltung für zeitgemäßes Wohnen
- **Persönlicher Service**: Wie unter Nachbarn`,

      whyUs: `In Poll sind wir wie Nachbarn. Wir nehmen uns Zeit, arbeiten sorgfältig und freuen uns, wenn das Ergebnis die Poller überzeugt.`
    },

    faq: [
      {
        question: "Kennen Sie die besonderen Bedingungen am Rhein?",
        answer: "Ja, wir wissen, dass Feuchtigkeit vom Rhein Fassaden und Keller belastet. Wir verwenden entsprechend robuste Materialien."
      },
      {
        question: "Arbeiten Sie auch an den älteren Fischerhäusern?",
        answer: "Ja, die traditionelle Architektur in Poll behandeln wir mit der nötigen Sorgfalt."
      },
      {
        question: "Wie ist der Umgang in Poll?",
        answer: "Persönlich und direkt. Wir passen uns an – und fühlen uns im dörflichen Poll sehr wohl."
      }
    ],

    nearbyAreas: [
      { name: "Deutz", slug: "deutz" },
      { name: "Porz", slug: "porz" },
      { name: "Ensen", slug: "ensen" },
      { name: "Westhoven", slug: "westhoven" }
    ],

    meta: {
      title: "Maler Köln-Poll | Rheinufer & Tradition | FarbWelt Service",
      description: "Ihr Maler in Poll ✓ Persönlich ✓ Rheinlage ✓ Dörflicher Charme. Malerarbeiten am Kölner Rheinufer!",
      keywords: "Maler Poll, Maler Köln-Poll, Haus streichen Poll"
    }
  }
};

export default seoContentKoeln2;
